// extracted by mini-css-extract-plugin
export var legendIndicator = "_hy-1";
export var legendRight = "_hy-0";